__turbopack_context__.v({
  "actions": "Xabtja_actions",
  "caption": "Xabtja_caption",
  "captionopen": "Xabtja_captionopen",
  "impactEstimate": "Xabtja_impactEstimate",
  "impactExplanationContainer": "Xabtja_impactExplanationContainer",
  "wrapper": "Xabtja_wrapper",
});
